import {
  Component,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'sp-add-photos-modal',
  templateUrl: './add-photos-modal.component.html',
  styleUrls: ['./add-photos-modal.component.scss'],
  standalone: false
})
export class AddPhotosModalComponent implements OnDestroy, AfterViewInit {
  
  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;  

  @Input() propertyId: string;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  value: any[] = [];

  readonly componentType = 'photo';

  private ngOnDestroy$ = new Subject();

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }

  showModal(): void {
    this.value = [];
    this.bsModal.show();
  }

  closeModal(): void {
    this.onClose.emit(true);
    this.bsModal.hide();
  }

  ngOnDestroy() {
    this.ngOnDestroy$.next('ngOnDestroy');
    this.ngOnDestroy$.unsubscribe();
  }
}
